import LibraryLayer from '../objects/LibraryLayer';

export function getGroupLayers(group) {
    return group.layers.map(layer => new LibraryLayer({
        id: layer.id,
        title: layer.title,
        visible: true,
    }));
}

export function getGroupLayersDefinition(group) {
    return [].concat(...group.layers.map(lay => lay.layers));
}

export function isPointBasedLayer(layer) {
    return ['symbol', 'circle', 'bubble'].indexOf(layer.type) > -1;
}

/** Our own tile server's source: a dragonfly source of layers and datasets. */
export function isSocialExplorerSource(source) {
    return !!source && Array.isArray(source.layers);
}

/**
 * Sources that are not our tile server (e.g. Esri raster tiles) are registered only
 * while a visible layer uses them, so a hidden layer requests nothing. A hidden
 * layer on such a source is dropped too: a layer whose source is missing from the
 * style fails to add.
 */
export function resolveExternalSources(groups, layers) {
    const external = {};
    groups.forEach(group => {
        Object.keys(group.sources || {}).forEach(id => {
            if (!isSocialExplorerSource(group.sources[id])) external[id] = group.sources[id];
        });
    });

    const isVisible = layer => !layer.layout || layer.layout.visibility !== 'none';
    const sources = {};
    layers.forEach(layer => {
        if (external[layer.source] && isVisible(layer)) sources[layer.source] = external[layer.source];
    });

    return {
        sources,
        layers: layers.filter(layer => !external[layer.source] || sources[layer.source]),
    };
}
